import { httpGet } from '../../../utils/api.utils';
import { removePlusSign } from '../../../utils/helpers.utils';
import { CIRCUIT_CATEGORIES } from '../../../utils/constant.utils';
import {
    getMobileItems,
    getHomeItems,
    setMobileSearchValue,
    setHomeSearchValue,
    clearMobileSubscriptionItems,
    clearHomeSubscriptionItems,
    clearMobileSearchValue,
    clearHomeSearchValue,
    setItemPrimaryMobile,
    setItemPrimaryHome,
    getOtherSubscribersUnderLineManager,
    setSelectedUser,
    clearSelectedUser,
    setActiveCircuit,
    clearActiveCircuit,
    setTabKey,
    setMobileIsFetching,
    setHomeIsFetching,
    setIsPersonal,
    setSubscription,
    setCurrentToggleTab,
    setNoSubscriptionFound,
    setSubscribers,

    setLoadMoreSubscribers
} from '../../../constants/model-reducers/external/side-nav-menu/side-nav-menu.settings';

const initialState = {
    isPersonal: false,
    activeTabKey: 1,
    mobileItems: {
        Data: [],
        Pagination: {
            HasNext: true,
            HasPrevious: false,
        },
        isBeforeFetch: true,
        isFetching: false,
        renderLimit: 1
    },
    mobileSearchValue: '',
    homeItems: {
        Data: [],
        Pagination: {
            HasNext: true,
            HasPrevious: false,
        },
        isBeforeFetch: true,
        isFetching: false,
        renderLimit: 1
    },
    homeSearchValue: '',
    otherSubscribersList: [],
    subscribers: [],
    selectedUser: {
        EmployeeId: null,
        FullName: '',
        EId: '',
        EmailAddress: '',
        ContactNumber: '',
        Country: '',
        Location: '',
    },
    activeCircuit: {
        CircuitId: null,
        IsPrimaryNumber: false,
        UserId: null,
    },
    subscriptionItems: {
        isFetching: false
    },
    selectedToggleTab: "0",
    isNoSubscriptionFound: false,

    subscriberDataList: [],
    loadMoreSubscribers: true,
    subscriberListPage: 1,
    hasMoreSubscriberView: false,
    hasMoreCircuitView: false
};

export const sideNavMenuActions = {
    fetchSubscriptionItems: (isMobile, index, isFetchingItems = true, renderLimit = 1) => async (dispatch, state) => {
        var sideNavMenuState = state().sideNavMenu;
        var empId = sideNavMenuState.selectedUser.EmployeeId ? sideNavMenuState.selectedUser.EmployeeId : sessionStorage.EmployeeID;
        var searchString = '';
        var currentItems = [];
        var pagination = {};
        var beforeFetch = false;
        var type = '';
        var isFetchingType = '';

        if (isMobile) {
            searchString = sideNavMenuState.mobileSearchValue;
            currentItems = sideNavMenuState.mobileItems.Data;
            pagination = sideNavMenuState.mobileItems.Pagination;
            type = getMobileItems;
            isFetchingType = setMobileIsFetching;
        } else {
            searchString = sideNavMenuState.homeSearchValue;
            currentItems = sideNavMenuState.homeItems.Data;
            pagination = sideNavMenuState.homeItems.Pagination;
            type = getHomeItems;
            isFetchingType = setHomeIsFetching;
        }

        dispatch({
            type: isFetchingType,
            isFetching: isFetchingItems,
        });

        searchString = removePlusSign(searchString);

        const { mobileItems, homeItems } = state().sideNavMenu;

        const lastLoadedCircuitID = isMobile
            ? (mobileItems.Data.length > 0
                ? mobileItems.Data[mobileItems.Data.length - 1].CircuitId
                : 0)
            : (homeItems.Data.length > 0
                ? homeItems.Data[homeItems.Data.length - 1].CircuitId
                : 0);

        var res = await httpGet('external/nav/getSubscriptions/' + parseInt(empId, 10) + '/' + index + '/' + isMobile + '/' + lastLoadedCircuitID + '/' + searchString);

        var combinedItems = {
            Data: res.ok == false ? [...currentItems] : [...currentItems, ...res.Data],
            Pagination: res.ok == false ? pagination : res.Pagination,
            isBeforeFetch: beforeFetch,
            renderLimit: renderLimit + 1
        };

        dispatch({
            type: type,
            items: combinedItems,
            hasMoreCircuit: res.hasMoreCircuit
        });

        dispatch({
            type: isFetchingType,
            isFetching: false,
        });

        if (isFetchingType == setHomeIsFetching) {
            if (combinedItems.Data.length == 0) {
                dispatch({
                    type: setNoSubscriptionFound,
                    data: true,
                });
            } else {
                dispatch({
                    type: setNoSubscriptionFound,
                    data: false,
                });
            }
        }

        return Promise.resolve(true);
    },
    setSearchValue: (isMobile, searchValue) => (dispatch) => {
        var type = isMobile ? setMobileSearchValue : setHomeSearchValue;

        dispatch({
            type: type,
            searchValue: searchValue,
        });
    },
    clearSubscriptionItems: (isMobile) => (dispatch) => {
        var type = isMobile ? clearMobileSubscriptionItems : clearHomeSubscriptionItems;

        dispatch({
            type: type,
        });
    },
    clearSearchValue: (isMobile) => (dispatch) => {
        var type = isMobile ? clearMobileSearchValue : clearHomeSearchValue;

        dispatch({
            type: type,
        });
    },
    setActiveItemPrimary: (circuit) => (dispatch) => {
        var type = circuit.CircuitCategoryId == CIRCUIT_CATEGORIES.mobile ? setItemPrimaryMobile : setItemPrimaryHome;

        dispatch({
            type: type,
            circuitId: circuit.CircuitId,
            isPrimaryNumber: circuit.IsPrimaryNumber,
            circuitCategoryId: circuit.CircuitCategoryId,
        });
    },
    fetchActiveSubscribers: (employeeId) => async (dispatch) => {
        var otherSubscribersList = await httpGet('external/otherSubscribers/getFirstLevelSubscribers/' + employeeId);

        dispatch({
            type: getOtherSubscribersUnderLineManager,
            otherSubscribersList: Object.keys(otherSubscribersList).length > 0 ? otherSubscribersList : [],
        });
    },
    setSelectedUser: (selectedUser) => async (dispatch) => {
        dispatch({
            type: setSelectedUser,
            selectedUser: selectedUser,
        });
    },
    clearSelectedUser: () => (dispatch) => {
        dispatch({
            type: clearSelectedUser,
        });
    },
    setActiveCircuit: (activeCircuit) => (dispatch) => {
        dispatch({
            type: setActiveCircuit,
            activeCircuit: activeCircuit,
        });
    },
    clearActiveCircuit: () => (dispatch) => {
        dispatch({
            type: clearActiveCircuit,
        });
    },
    setActiveTabKey: (tabKey) => (dispatch) => {
        dispatch({type: setTabKey, data: tabKey});
    },
    setIsPersonal: (isPersonal) => (dispatch) => {
        dispatch({ type: setIsPersonal, data: isPersonal});
    },
    onChangeUserSearch: (val) => async (dispatch, state) => {
        const selected = state().sideNavMenu.selectedUser.FullName;

        if (!val || val === selected) return null;

        var res = await httpGet(
            'external/autosuggest/getEmployees/' +
                sessionStorage.EmployeeID +
                '/' +
                sessionStorage.UserRoleID +
                '/' +
                sessionStorage.IsExecutive +
                '/' +
                sessionStorage.IsKeyUser +
                '/' +
                val + '/' +
                false + '/' +
                0 + '/' +
                true
        );

        dispatch({
            type: getOtherSubscribersUnderLineManager,
            otherSubscribersList: res,
        });

        return res ? res : null;
    },
    setCurrentToggleTab: (curToggleTab) => (dispatch) => {
        dispatch({ type: setCurrentToggleTab, data: curToggleTab });
    },
    fetchAllSubscribers: (searchString, pageIndex = 1) => async (dispatch, state) => {
        const pageSize = 15;
        const lastLoadedsubscriberID = 0;

        var res = await httpGet(`external/autosuggest/getAllSubscribers/${parseInt(sessionStorage.EmployeeID)}/${sessionStorage.Idhr}/${parseInt(sessionStorage.UserRoleID)}/${pageIndex}/${pageSize}/${lastLoadedsubscriberID}/${searchString}`);

        dispatch({
            type: setSubscribers,
            subscribers: res,
            subscriberListPage: pageIndex
        });

        return res ? res : [];
    },

    fetchAllSubscribersViewMore: () => async (dispatch, state) => {
        const loadedSubscriber = state().sideNavMenu.subscriberDataList || [];

        const lastLoadedsubscriberID = loadedSubscriber.length > 0
                                ? loadedSubscriber[loadedSubscriber.length - 1].EmployeeId : 0;

        const pageSize = 5;

        var res = await httpGet(`external/autosuggest/getAllSubscribersViewMore/${parseInt(sessionStorage.EmployeeID)}/${sessionStorage.Idhr}/${parseInt(sessionStorage.UserRoleID)}/${pageSize}/${lastLoadedsubscriberID}`);

        dispatch({
            type: setLoadMoreSubscribers,
            subscriberDataList: res.subscribers,
            hasMoreSubscriberView: res.hasMoreData
        });

        return res ? res : [];
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getMobileItems:
            return {
                ...state,
                mobileItems: action.items,
                hasMoreCircuitView: action.hasMoreCircuit
            };
        case getHomeItems:
            return {
                ...state,
                homeItems: action.items,
                hasMoreCircuitView: action.hasMoreCircuit
            };
        case setMobileSearchValue:
            return {
                ...state,
                mobileSearchValue: action.searchValue,
                mobileItems: initialState.mobileItems
            };
        case setHomeSearchValue:
            return {
                ...state,
                homeSearchValue: action.searchValue,
                homeItems: initialState.homeItems
            };
        case clearMobileSubscriptionItems:
            return {
                ...state,
                mobileItems: initialState.mobileItems,
            };
        case clearHomeSubscriptionItems:
            return {
                ...state,
                homeItems: initialState.homeItems,
            };
        case clearMobileSearchValue:
            return {
                ...state,
                mobileSearchValue: initialState.mobileSearchValue,
            };
        case clearHomeSearchValue:
            return {
                ...state,
                homeSearchValue: initialState.homeSearchValue,
            };
        case setItemPrimaryMobile:
            var index;
            var data = state.mobileItems.Data.map((item, i) => {
                if (item.CircuitId === action.circuitId) (index = i);
                return {
                    ...item,
                    IsPrimaryNumber: item.CircuitId === action.circuitId ? action.isPrimaryNumber : !action.isPrimaryNumber,
                };
            });
            data.unshift(data.splice(index, 1)[0]);
            return {
                ...state,
                mobileItems: {
                    ...state.mobileItems,
                    Data: data,
                },
            };
        case setItemPrimaryHome:
            var index;
            var data = state.homeItems.Data.map((item, i) => {
                if (item.CircuitId === action.circuitId) (index = i);
                return {
                    ...item,
                    IsPrimaryNumber:
                        item.CircuitId == action.circuitId
                            ? action.isPrimaryNumber
                            : item.CircuitCategoryId == action.circuitCategoryId
                                ? !action.isPrimaryNumber
                                : item.IsPrimaryNumber,
                };
            });
            data.unshift(data.splice(index, 1)[0]);
            return {
                ...state,
                homeItems: {
                    ...state.homeItems,
                    Data: data,
                },
            };
        case getOtherSubscribersUnderLineManager:
            return {
                ...state,
                otherSubscribersList: action.otherSubscribersList,
            };
        case setSelectedUser:
            return {
                ...state,
                selectedUser: action.selectedUser,
            };
        case clearSelectedUser:
            return {
                ...state,
                selectedUser: initialState.selectedUser,
            };
        case setActiveCircuit:
            return {
                ...state,
                activeCircuit: action.activeCircuit,
            };
        case clearActiveCircuit:
            return {
                ...state,
                activeCircuit: initialState.activeCircuit,
            };
        case setTabKey:
            return {
                ...state,
                activeTabKey: action.data,
            };
        case setIsPersonal:
            return {
                ...state,
                isPersonal: action.data,
            };
        case setMobileIsFetching:
            return {
                ...state,
                mobileItems: {
                    ...state.mobileItems,
                    isFetching: action.isFetching,
                },
            };
        case setHomeIsFetching:
            return {
                ...state,
                homeItems: {
                    ...state.homeItems,
                    isFetching: action.isFetching,
                },
            };
        case setSubscription:
            return {
                ...state,
                subscriptionItems: {
                    ...state.subscriptionItems,
                    isFetching: action.isFetching,
                },
            };
        case setCurrentToggleTab:
            return {
                ...state,
                selectedToggleTab: action.data,
            };
        case setNoSubscriptionFound:
            return {
                ...state,
                isNoSubscriptionFound: action.data,
            };
        case setSubscribers:
            const newSubscriberList = Array.isArray(action.subscribers) ? action.subscribers : [];
            return {
                ...state,
                subscribers: action.subscriberListPage === 1
                    ? action.subscribers
                    : [...state.subscribers, ...newSubscriberList]
                , loadMoreSubscribers: action.subscribers > 0
                , subscriberListPage: action.subscriberListPage   
            }
        case setLoadMoreSubscribers:
            const newSubscriberViewMore = Array.isArray(action.subscriberDataList) ? action.subscriberDataList : [];
            return {
                ...state,
                subscriberDataList: [...state.subscriberDataList, ...newSubscriberViewMore]
                , hasMoreSubscriberView: action.hasMoreSubscriberView
            }
        default:
            return state;
    }
};
